<template>
  <div class="simple-list">
    <component
      :is="item.path ? 'router-link' : 'article'"
      v-for="item in items"
      :key="$pick(item.title || item)"
      v-reveal
      class="list-card"
      :to="item.path || undefined"
    >
      <h3>{{ $pick(item.title || item) }}</h3>
      <p v-if="item.description || item.summary">{{ $pick(item.description || item.summary) }}</p>
    </component>
  </div>
</template>

<script>
export default {
  name: "SimpleCardList",
  props: {
    items: Array
  }
};
</script>

<style scoped>
.simple-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.list-card {
  display: block;
  padding: 24px;
  background: #fff;
  border: 1px solid var(--line);
  box-shadow: var(--shadow);
  color: inherit;
  transition: transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease;
}

a.list-card:hover {
  transform: translateY(-4px);
  border-color: rgba(18, 95, 166, 0.32);
  box-shadow: 0 18px 42px rgba(10, 31, 58, 0.13);
}

.list-card h3 {
  margin: 0 0 10px;
  color: var(--brand-blue-deep);
}

.list-card p {
  margin: 0;
  color: #5f6976;
  line-height: 1.8;
}

@media (max-width: 900px) {
  .simple-list {
    grid-template-columns: 1fr;
  }
}
</style>
